/**
 * Builds a landing-page URL with the external id appended as a properly encoded
 * query parameter. Using URL + URLSearchParams ensures the externalId value is
 * percent-encoded, so an attacker-controlled value cannot inject additional
 * query parameters, a fragment, or otherwise alter the redirect target
 * (CWE-601 open redirect / parameter injection).
 *
 * @param {string} basePage - Absolute landing-page URL (may already carry a query string).
 * @param {string} paramName - Query parameter name to set (e.g. 'external_id').
 * @param {string} paramValue - The external id value (untrusted).
 * @returns {string} The safe, fully-encoded landing-page URL.
 */
export function buildLandingUrl(basePage, paramName, paramValue) {
  const url = new URL(basePage, window.location.origin);
  url.searchParams.set(paramName, paramValue ?? '');
  return url.toString();
}

/**
 * Navigates the current window to a landing page built via buildLandingUrl.
 */
export function redirectToLanding(basePage, paramName, paramValue) {
  window.open(buildLandingUrl(basePage, paramName, paramValue), '_self');
}
